import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const navigate = useNavigate();

  const fetchContacts = async () => {
    try {
      const res = await fetch(
        "https://lifetimeinfotech.in/backend/getContacts.php"
      );
      const data = await res.json();
      setContacts(data);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // Logout Function
  const handleLogout = () => {
    localStorage.removeItem("adminAuth"); // remove login data
    navigate("/lifetimeMyAdmin/"); // redirect to login page
  };

  return (
    <div style={{ padding: "20px" }}>
      
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h1>Contact Messages</h1>

        <button
          onClick={handleLogout}
          style={{
            padding: "8px 18px",
            background: "#e74c3c",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
            fontWeight: "bold",
          }}
        >
          Logout
        </button>
      </div>

      <table border="1" cellPadding="10" width="100%">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Subject</th>
            <th>Phone</th>
            <th>Message</th>
          </tr>
        </thead>

        <tbody>
          {contacts.length > 0 ? (
            contacts.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.subject}</td>
                <td>{item.phone}</td>
                <td>{item.message}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No messages found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminContacts;